export default "images/upTriangle.svg";